import React, {Component} from 'react';
import './App.css';
import './css/all.css';

import Test from './components/test/Test';
import TestEditor from "./components/testedit/TestEditor";
import TestChecker from "./components/testcheck/TestChecker";
import API from "./api/API";
import LoadingScreen from "./components/LoadingScreen";
import TestList from "./components/TestList";
import TestView from "./components/TestView";

class App extends Component {

    componentWillMount() {
        this.openList();
    }

    openList = () => {
        let screen = <LoadingScreen/>;

        this.setState({ screen: <LoadingScreen/>, user: null });

        API.callAPI('user/')
            .then(response => {
                if (!response['error']) {
                    screen = <TestList
                        openView={this.openView}
                        openCheck={this.openCheck}
                        user={response}
                    />
                }

                this.setState({ user: response, screen: screen });
            });
    };

    openView = (id) => {
        this.setState({
            screen: <TestView id={id} user={this.state.user} openView={this.openView} openList={this.openList} />
        });
    };

    openCheck = (id, user_id) => {
        this.setState({
            screen: <TestChecker id={id} user_id={user_id} user={this.state.user} openView={this.openView} openList={this.openList} />
        })
    };

    render() {
        return (
            <div className="App">
                {this.state.screen}
            </div>
        );
    }
}

export default App;
